/**
 * Lista de todas as chaves de localStorage que armazenam filtros e preferências
 * específicas do usuário. Essas chaves devem ser limpas no login para evitar
 * que filtros de uma conta persistam em outra.
 */
const USER_FILTER_KEYS = [
  // CRM Module
  'crm_advanced_filters',
  'crm_selected_funnel_id',
  'crm_sidebar_open',
  'crm_view_mode',
  'crm_card_density',

  // Helpdesk/Tickets Module
  // `cardDensity` vive DENTRO de `tickets_preferences` (blob) — sem chave própria.
  'tickets_advanced_filters',
  'tickets_preferences',

  // Chat Module
  'chat_show_only_my_attendances',
  'chat_left_sidebar_expanded',
  'chat_right_sidebar_open',
  'chat_current_view',

  // View Mode Preferences (various modules)
  'users_view_mode',
  'channels_view_mode',
  'teams_view_mode',
  'levels_view_mode',

  // Attendance Management
  'attendance_sidebar_open',
  'attendance_card_density',

  // AI Agents
  'troia:agents-config',

  // App-wide sidebar preferences
  'app_sidebar_collapsed',
  'app_sidebar_expanded_menus',
] as const;

/**
 * Limpa todos os filtros e preferências do usuário salvos no localStorage.
 * Deve ser chamado no login para garantir que um usuário não herde
 * filtros de outra conta que estava logada anteriormente.
 */
export function clearUserFilters(): void {
  USER_FILTER_KEYS.forEach((key) => {
    localStorage.removeItem(key);
  });
}

/**
 * Retorna a lista de chaves que são limpas no login.
 * Útil para debug e documentação.
 */
export function getUserFilterKeys(): readonly string[] {
  return USER_FILTER_KEYS;
}
